import { render, staticRenderFns } from "./ProfilePrivilegeList.vue?vue&type=template&id=6d805dc6&scoped=true&"
import script from "./ProfilePrivilegeList.vue?vue&type=script&lang=js&"
export * from "./ProfilePrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePrivilegeList.vue?vue&type=style&index=0&id=6d805dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d805dc6",
  null
  
)

export default component.exports